import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormControl, FormGroup, Col, ControlLabel, Button, Glyphicon } from 'react-bootstrap';
const passwordFeedbackIcon = <Glyphicon glyph="lock" />;

const validate = values => {
  const errors = {};

  if (!values.passwordOne) {
    errors.passwordOne = 'Required';
  }
  if (!values.passwordTwo) {
    errors.passwordTwo = 'Required';
  }

  if (values.passwordOne !== values.passwordTwo) {
    errors.passwordTwo = 'Password must match';
  }

  return errors;
};

const warn = values => {
  const warnings = {};
  return warnings;
};

const renderField = ({ feedbackIcon, input, label, type, meta: { touched, error, warning } }) => {
  const validationState = (touched && (error && 'error')) || (warning && 'warning') || null;
  const style = { borderRadius: 0, color: '#265886' };

  return (
    <FormGroup controlId={input.name} validationState={validationState}>
      <Col xs={12} componentClass={ControlLabel}>
        <div style={style}>
          <h4>
            {label}
            <span style={{ color: 'red' }}> *</span>
          </h4>
        </div>
      </Col>
      <Col xs={12}>
        <FormControl {...input} placeholder={label} type={type} style={style} />
        {feedbackIcon ? (
          <FormControl.Feedback style={{ marginRight: '15px' }}>{feedbackIcon}</FormControl.Feedback>
        ) : null}
        {touched &&
          ((error && <span className="help-block text-left">{error}</span>) ||
            (warning && <span className="help-block text-left">{warning}</span>))}
      </Col>
    </FormGroup>
  );
};

const ChangePasswordForm = props => {
  const { handleSubmit, pristine, submitting, error } = props;
  return (
    <form onSubmit={handleSubmit} className="text-left">
      <Field
        name="passwordOne"
        type="password"
        component={renderField}
        label="New Password"
        feedbackIcon={passwordFeedbackIcon}
      />
      <Field
        name="passwordTwo"
        type="password"
        component={renderField}
        label="Repeat Password"
        feedbackIcon={passwordFeedbackIcon}
      />
      <Col xs={12}>
        <Button
          bsStyle="primary"
          type="submit"
          disabled={submitting || pristine}
          style={{ margin: '20px 0', borderRadius: 0 }}
        >
          Save
        </Button>
        {error && <strong style={{ color: 'red', marginLeft: '5px' }}>{error}</strong>}
      </Col>
    </form>
  );
};

export default reduxForm({
  form: 'forgotpassword', // a unique identifier for this form
  validate, // <--- validation function given to redux-form
  warn // <--- warning function given to redux-form
})(ChangePasswordForm);



// WEBPACK FOOTER //
// ./src/containers/ChangePasswordPage/Form/index.js